export const skills = [
    {
        id:1,
        link:'https://roadmap.sh/frontend',
        subject:'Frontend',
        startGrad:'from-[#4AC29A]',
        endGrad:'to-[#1CB5E0]',
        content:'It is used to design the platform graphical user interface for websites and apps utilizing specific technologies like HTML, CSS, and Javascript'
    },
    {
        id:2,
        link:'https://roadmap.sh/backend',
        subject:'Backend',
        startGrad:'from-[#56CCF2]',
        endGrad:'to-[#2F80ED]',
        content:'The emphasis is on databases, servers, and application programming interfaces, and it assures working with server-side applications (API)'
    },
    {
        id:3,
        link:'https://roadmap.sh/android',
        subject:'Android',
        startGrad:'from-[#159957]',
        endGrad:'to-[#155799]',
        content:'This development is used to create apps and software for android devices and play store across a large working organization'
    },
    {
        id:4,
        link:'https://www.geeksforgeeks.org/complete-roadmap-to-learn-dsa-from-scratch/',
        subject:'CP',
        startGrad:'from-[#FFAFBD]',
        endGrad:'to-[#ffc3a0]',
        content:'To run the code and get an output that solves the problem without errors, a set of guidelines and algorithms is used.'
    },
    {
        id:5,
        link:'https://roadmap.sh/blockchain',
        subject:'Blockchain',
        startGrad:'from-[#DCE35B]',
        endGrad:'to-[#45B649]',
        content:'It is a system of recording information in a way that minimizes the chances of hacking the system and ensures security and transparency.'
    },
    {
        id:6,
        link:'/others',
        subject:'Designing',
        startGrad:'from-pink-500',
        endGrad:'to-orange-400',
        content:'Using imaginative color schemes, patterns, and themes, graphic design is utilized to produce pictures that convey your thoughts.'
    },
]
